import Vue from 'vue'
import vuex from 'vuex'
import common from './common'
import education from './education'
import getters from './getters'
import register from './register'
Vue.use(vuex)

export default new vuex.Store({
  modules: {
    common: common,
    education: education,
    register: register,
  },
  getters,
})
